import { useMemo } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import styles from "./ContactSupportDialog.module.scss";
import { SUPPORT_URL, SUPPORT_PHONE } from "@/utils/externalPages";

interface ContactSupportDialogContentProps {
  showBookingQuestion?: boolean;
  supportId?: string;
}

export const ContactSupportDialogContent = ({
  showBookingQuestion = false,
  supportId,
}: ContactSupportDialogContentProps) => {
  const [, cn] = useModuleBEM(styles, "ContactSupportDialog");
  const { t } = useI18nContext();

  const supportPhone = useMemo(() => {
    if (supportId) {
      return `${SUPPORT_PHONE},,${supportId}#`;
    }
    return SUPPORT_PHONE;
  }, [supportId]);
  return (
    <>
      {showBookingQuestion && (
        <div className={cn("dialog-text")}>
          {t("hotels.bookingConfirmation.contactSupportDialog.question")}
        </div>
      )}
      <div className={cn("dialog-text")}>
        <Trans
          i18nKey="contactSupport.faqText"
          components={[
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            <a
              href={SUPPORT_URL}
              target="_blank"
              rel="noopener"
              referrerpolicy="no-referrer-when-downgrade"
              className={cn("dialog-link")}
            />,
          ]}
        />
      </div>
      <div className={cn("dialog-text")}>
        <Trans
          i18nKey="contactSupport.phoneText"
          components={[
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            <a href={`tel:${supportPhone}`} className={cn("dialog-link")} />,
          ]}
        />
      </div>
    </>
  );
};
